export enum RetrievalStatus {
    Configuration = 'DRAFT',
    Available = 'AVAILABLE',
    Deprecated = 'DEPRECATED_ASSET',
    Unavailable = 'NO_ACCESS',
}
